import {createSlice, Dispatch} from '@reduxjs/toolkit';
import {SeatClassRequest} from 'app/types/service-types/AircraftTypes';
import {SeatClassService} from 'app/services';
import {toggleQuickPanel} from 'app/main/shared-components/quick-panel/store';
import {fetchAllSeatClasses} from './seat-classes.slice';
import {errorMsg, successMsg} from 'app/utils/MessageUtils';

interface CreateSeatClassParams {
  body: SeatClassRequest;
  onSuccess?: Function;
  onError?: Function;
}

export const createSeatClass = (params: CreateSeatClassParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await SeatClassService.create(params.body);
    if (response.status === 201) {
      dispatch(setSuccess(true));
      dispatch(toggleQuickPanel());
      dispatch(successMsg('Seat class created successfully!'));
      if (params.onSuccess) params.onSuccess();
      dispatch(setError(''));
      // @ts-ignore
      dispatch(fetchAllSeatClasses());
    }
    dispatch(setLoading(false));
  } catch (err: any) {
    dispatch(setLoading(false));
    dispatch(errorMsg(err?.data?.message));
    if (params.onError) params.onError();
    dispatch(setError(err?.data?.message));
  }
}

interface CreateSeatClassSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: CreateSeatClassSlice = {
  error: '',
  success: false,
  loading: false
}

const stateSlice = createSlice({
  name: 'aircrafts/create-seat-class',
  initialState,
  reducers: {
    setLoading: (state, action) => { state.loading = action.payload },
    setSuccess: (state, action) => { state.success = action.payload },
    setError: (state, action) => { state.error = action.payload }
  }
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;
export default stateSlice.reducer;
